module.exports = __webpack_public_path__ + "img/animationTrack.669db5af.png";